import Reveal from "@/components/site/Reveal";
import { MOODBOARD } from "@/lib/content";

const heightMap = {
    short: "h-[28vh] lg:h-[36vh]",
    medium: "h-[40vh] lg:h-[52vh]",
    tall: "h-[56vh] lg:h-[72vh]",
};

export default function Moodboard() {
    return (
        <section
            data-testid="moodboard-section"
            className="bg-[#0a0a0a] text-white px-6 sm:px-10 lg:px-16 py-24 lg:py-32 border-t border-white/10"
        >
            <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
                <div className="max-w-3xl">
                    <Reveal>
                        <p className="text-[11px] uppercase tracking-[0.3em] text-white/50 mb-8">
                            04 · Inspiration
                        </p>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-medium leading-[0.95] tracking-tight">
                            A quiet
                            <br />
                            moodboard.
                        </h2>
                    </Reveal>
                </div>
                <Reveal delay={0.2}>
                    <p className="max-w-sm text-sm text-white/60 font-light leading-relaxed">
                        Textures, fittings, and black-and-white frames that shape what
                        we make. Pulled from our archive and the streets we walk.
                    </p>
                </Reveal>
            </div>

            <div className="columns-1 md:columns-2 lg:columns-3 gap-4 lg:gap-6 [column-fill:_balance]">
                {MOODBOARD.map((m, i) => (
                    <Reveal
                        key={i}
                        delay={(i % 3) * 0.1}
                        y={50}
                        className="mb-4 lg:mb-6 break-inside-avoid"
                    >
                        <div
                            data-testid={`moodboard-tile-${i}`}
                            className={`relative overflow-hidden group ${heightMap[m.h]}`}
                        >
                            <img
                                src={m.src}
                                alt=""
                                className="w-full h-full object-cover grayscale transition-all duration-[1400ms] ease-out group-hover:scale-105 group-hover:grayscale-0"
                            />
                            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-700" />
                            <div className="absolute bottom-3 left-3 text-[10px] uppercase tracking-[0.3em] text-white/60 font-mono-custom opacity-0 group-hover:opacity-100 transition-opacity duration-700">
                                Frame · {String(i + 1).padStart(2, "0")}
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </section>
    );
}
